import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RedirectCommand,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigurationFacade } from '../facades/configuration.facade';

@Injectable({
  providedIn: 'root',
})
export class LanguageGuard implements CanActivate {
  private readonly router: Router = inject(Router);
  private readonly configFacade: ConfigurationFacade = inject(ConfigurationFacade);

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree | RedirectCommand> | Promise<boolean | UrlTree | RedirectCommand> | boolean | UrlTree | RedirectCommand {
    const parsedUrl: UrlTree = this.router.parseUrl(state.url);
    const languageSegment: any = parsedUrl.root.children['primary'] ? parsedUrl.root.children['primary'].segments[0] : undefined;

    if (languageSegment) {
      if (this.configFacade.getLanguageRegex().exec(languageSegment.path)) {
        const [language, marketCode]: string[] = this.configFacade.getLangParamData(languageSegment.path);

        if (
          this.configFacade.validateMarket(marketCode) &&
          this.configFacade.validateLanguage(`${language}-${marketCode.toUpperCase()}`)
        ) {
          return true;
        } else this.router.navigateByUrl('/').then();

      } else this.router.navigateByUrl('/').then();
    }

    return true;
  }
}
